import { render, staticRenderFns } from "./SubMenuEntity.vue?vue&type=template&id=155b2c1b"
import script from "./SubMenuEntity.vue?vue&type=script&lang=ts"
export * from "./SubMenuEntity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports